import PropTypes from 'prop-types';
import React from 'react';
import { LINKEDIN_TEXT } from '../../config/text/text';

const EditorialTeamSection = ({ editorDetails }) => {
  return (
    <>
      <div className="editor-section-container">
        <div className="top-row">
          <img alt={editorDetails.alt} src={editorDetails.image} />
        </div>
        <div className="content-row">
          <h2>{editorDetails.title}</h2>
          <span>{editorDetails.content}</span>
          <span>
            Email:{' '}
            <a href={`mailto:${editorDetails.email}`}>{editorDetails.email}</a>
          </span>
          <div>
            <span>{LINKEDIN_TEXT} </span>

            <span>
              <a href={editorDetails.linkedin} rel="noreferrer" target="_blank">
                {editorDetails.linkedin}
              </a>
            </span>
          </div>
        </div>
      </div>
      <style jsx>{`
        .editor-section-container {
          display: flex;
          flex-direction: row;
          padding: 16px;
          border-top: 1px solid #ddd;
          align-items: center;
        }

        .editor-section-container img {
          border-radius: 50%;
          width: 150px;
          height: 150px;
          object-fit: cover;
          margin-right: 16px;
        }

        .editor-section-container div {
          flex-grow: 1;
        }

        .editor-section-container h2 {
          margin: 0;
          font-size: 18px;
          font-weight: bold;
        }
        .linkedin-section {
          display: flex;
          flex-direction: row;
        }
        .editor-section-container span {
          display: block;
          margin-top: 4px;
        }

        .editor-section-container span:first-of-type {
          margin-top: 8px;
        }

        @media (max-width: 768px) {
          .editor-section-container {
            flex-direction: column;
            align-items: center;
            padding-top: 9%;
          }

          .top-row {
            display: flex;
            flex-direction: row;
            width: 100%;
            align-items: center;
            justify-content: center;
            margin-bottom: 8px;
          }

          .editor-section-container img {
            width: 120px;
            height: 120px;
            margin-right: 16px;
            border-radius: 0%; /* Ensure image remains circular */
          }

          .editor-section-container h2 {
            font-size: 16px;
            text-align: center;
          }

          .content-row {
            text-align: left;
            width: 100%;
            padding: 0 16px; /* Add padding to both sides */
          }

          .editor-section-container span {
            font-size: 14px;
          }

          .editor-section-container span:first-of-type {
            margin-top: 8px;
          }
        }
      `}</style>
    </>
  );
};

export default EditorialTeamSection;

EditorialTeamSection.propTypes = {
  editorDetails: PropTypes.object,
};
